<template>
  <div class="page">
    <NavBar :title="lang('积分充值')" :self-click="true" @go-back="goBack()" />
    <Line style="{'height': '1px', width: '100%'}" />
    <score-step :active-value="active" />
    <div class="content">
      <step1 v-if="active === 0" />
      <step2
        v-if="active === 1"
        @finish="(value, status) => commit(value, status)"
      />
      <step3 v-if="active === 2" :id="id" />
    </div>
    <btn-box
      v-if="active !== 2"
      :active="active"
      :light="light"
      @click="click"
    />
  </div>
</template>

<script lang="ts" setup>
import lang from '@/langs'
import NavBar from '@core/components/NavBar.vue'
import Line from '@core/components/line.vue'
import ScoreStep from '@/views/score/component/scoreRecharge/scoreStep.vue'
import Step1 from '@/views/score/component/scoreRecharge/step1.vue'
import { ref } from 'vue'
import BtnBox from '@/views/score/component/scoreRecharge/btnBox.vue'
import Step3 from '@/views/score/component/scoreRecharge/step3.vue'
import Step2 from '@/views/score/component/scoreRecharge/step2.vue'
import { useRoute, useRouter } from 'vue-router'
import { destroyH5 } from '@core/utils/nativeAPI'
import { Remittance } from '@/api/requests/score'
import { showToast } from 'vant'
import {
  limited1_50,
  validateAmount,
  validatePositiveNumericInput
} from '@/views/score/utils/rule'
import { RemittanceReq } from '@/model/score/score'
import { debounce } from 'lodash'
const route = useRoute()
const id = ref(route?.query?.id || '')
const isH5 = ref(route?.query?.isH5 || '')
const router = useRouter()
const active = ref(route?.query?.id ? 2 : 0)
const param = ref<RemittanceReq>()
const goBack = () => {
  if (isH5.value) {
    router.go(-1)
  } else {
    destroyH5()
  }
}
const light = ref(true)
function areAllValuesNotEmpty(obj) {
  return Object.values(obj).every(
    (value) => value !== null && value !== undefined && value !== '' // 根据需求调整条件
  )
}
const click = debounce((value: number) => {
  if (!areAllValuesNotEmpty(param?.value || {})) {
    return
  }
  if (active.value === 1) {
    //第二步
    if (limited1_50(param?.value?.applyName || '')) {
      showToast(lang('姓名长度为1-50位'))
      return
    }
    if (limited1_50(param?.value?.bankAccount || '')) {
      showToast(lang('银行账号长度为1-50位'))
      return
    }
    if (validateAmount(param?.value?.applyAmount || '')) {
      showToast(lang('请输入0.01到50000.00之间的金额'))
      return
    }
    if (!validatePositiveNumericInput(param?.value?.applyAmount || '')) {
      showToast(lang('请输入正确的金额'))
      return
    }
    Remittance(param.value).then((value) => {
      if (value.code === 1 && value.data !== null) {
        id.value = value.data?.id || '0'
        active.value = 2
      } else {
        if (value.code === 15001) {
          showToast(lang('JMS系统驿站账户未开账，请联系管理员'))
        } else {
          showToast(lang('充值失败'))
        }
      }
    })
  } else {
    //第一步
    active.value = value
    light.value = false
  }
}, 500) // 500ms 内如果多次触发，只执行最后一次
// const click = (value: number) => {
//
// }

const commit = (value: RemittanceReq, status: boolean) => {
  light.value = status
  param.value = value
}
</script>
<script lang="ts">
export default {
  name: 'ScoreCharge'
}
</script>
<style scoped lang="less">
.page {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  .content {
    flex: 1;
    overflow: scroll;
    z-index: 2;
  }
}
</style>
